import "./PreviousOrders.css";
import OrderCard from "./OrderCard";

function PreviousOrders({ orders }) {

    return (

        <div className="previous-orders">

            <div className="previous-orders-title">

                <h2>

                    Previous Orders

                </h2>

                <span className="previous-orders-count">

                    {orders.length} Orders

                </span>

            </div>

            {orders.map((order) => (

                <OrderCard
                    key={order._id}
                    order={order}
                />

            ))}

        </div>

    );

}

export default PreviousOrders;